exports.AudanetTaskListView = {
  path: '/audanettasks',
  name: 'AudanetTaskListView'
}
